<template>
    <v-container fluid>
        <ReadHeader :current="current" />

        <v-row>
            <v-col>
                <KeyValue :title="`Job Order Number`" :value="entityCore.work_order_number"></KeyValue>
            </v-col>
            <v-col>
                <KeyValue :title="`Status`" :value="entityCore.work_order_status"></KeyValue>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <KeyValue :title="`Contract`" :value="nameById(entityCore.contract_uid)"></KeyValue>
            </v-col>
            <v-col>
                <KeyValue :title="`Stage`" :value="entityCore.stage"></KeyValue>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <KeyValue :title="`Location Info`" :value="entityCore.location_info"></KeyValue>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <KeyValue :title="`Scope of Work`" :value="entityCore.scope_of_work"></KeyValue>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <h3>Owner Project Managers</h3>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <KeyValue :title="`Primary Owner Project Manager`"
                    :value="nameById(entityCore.owner_project_manager_primary_uid)"></KeyValue>
            </v-col>
            <v-col>
                <KeyValue :title="`Secondary Owner Project Manager`"
                    :value="nameById(entityCore.owner_project_manager_2_uid, null)"></KeyValue>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="6">
                <KeyValue :title="`Tertiary Owner Project Manager`"
                    :value="nameById(entityCore.owner_project_manager_3_uid, null)"></KeyValue>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <h3>Contractor Project Managers</h3>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <KeyValue :title="`Primary Contractor Project Manager`"
                    :value="nameById(entityCore.contractor_project_manager_primary_uid)"></KeyValue>
            </v-col>
            <v-col>
                <KeyValue :title="`Secondary Contractor Project Manager`"
                    :value="nameById(entityCore.contractor_project_manager_2_uid, null)"></KeyValue>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="6">
                <KeyValue :title="`Tertiary Contractor Project Manager`"
                    :value="nameById(entityCore.contractor_project_manager_3_uid, null)"></KeyValue>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <h3>Approvers</h3>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <KeyValue :title="`Inspector`" :value="nameById(entityCore.inspector_uid)"></KeyValue>
            </v-col>
            <v-col>
                <KeyValue :title="`RFP Signing Authority`" :value="nameById(entityCore.rfp_signing_authority_uid)">
                </KeyValue>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <KeyValue :title="`NTP Signing Authority`" :value="nameById(entityCore.ntp_signing_authority_uid)">
                </KeyValue>
            </v-col>
            <v-col>
                <KeyValue :title="`JOA Signing Authority`" :value="nameById(entityCore.woa_signing_authority_uid)">
                </KeyValue>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <h3>Calculated Dates</h3>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="6">
                <KeyValue :title="`Duration`" :value="entityCore.duration + ' days'"></KeyValue>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <h3>Administrative Dates</h3>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <KeyValue :title="`Site Walk Through Date`" :value="formatDate(entityCore.site_walk_through_date)">
                </KeyValue>
            </v-col>
            <v-col>
                <KeyValue :title="`RFP Issue Date`" :value="formatDate(entityCore.rfp_issue_date)"></KeyValue>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <KeyValue :title="`Proposal Due Date`" :value="formatDate(entityCore.proposal_due_date)"></KeyValue>
            </v-col>
            <v-col>
                <KeyValue :title="`Accepted Proposal Date`" :value="formatDate(entityCore.accepted_proposal_date)">
                </KeyValue>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <KeyValue :title="`Job Order Authorization Date`"
                    :value="formatDate(entityCore.work_order_authorization_date)"></KeyValue>
            </v-col>
            <v-col>
                <KeyValue :title="`NTP Issued Date`" :value="formatDate(entityCore.ntp_issued_date)"></KeyValue>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <KeyValue :title="`EEO Clearance Date`" :value="formatDate(entityCore.eeo_clearance_date)"></KeyValue>
            </v-col>
            <v-col>
                <KeyValue :title="`Notice of Completion File Date`"
                    :value="formatDate(entityCore.notice_of_completion_file_date)"></KeyValue>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <h3>Fees & Damages</h3>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <KeyValue :title="`Liquidated Damages to District`" :value="liquidatedDamagesToDistrict"></KeyValue>
            </v-col>
            <v-col>
                <KeyValue :title="`Liquidated Damages to Contractor`" :value="liquidatedDamagesToContractor"></KeyValue>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="6">
                <KeyValue :title="`JAMB Fee Percentage`" :value="jambFeePerecentage"></KeyValue>
            </v-col>
        </v-row>

        <TableList :current="current" :details="supplementalProposalsDetails" />



        <v-row><v-col><v-divider></v-divider></v-col></v-row>

        <v-row>
            <v-col>
                <h3>Supplemental Job Order Authorizations</h3>
            </v-col>
            <v-col class="d-flex ga-4 justify-end" v-if="$hasPermission(`document:generate`)">
                <v-btn color="primary" variant="outlined" @click="generateJobOrderAuthorization()">
                    Generate
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-data-table :headers="tableHeaders" :items="jobOrderAuthorizationFileList"
                    :loading="jobOrderAuthorizationFileListLoading" loading-text="Loading..." item-value="Key"
                    :items-per-page="10">


                    <template v-slot:[`item.Key`]="{ item }">
                        {{ getFileName(item.Key) }}
                    </template>
                    <template v-slot:[`item.Size`]="{ item }">
                        {{ bytesToSize(item.Size) }}
                    </template>

                    <template v-slot:[`item.LastModified`]="{ item }">
                        <span v-html="getCreatedDate(item.LastModified)"></span>
                    </template>

                    <template v-slot:[`item.Action`]="{ item }">
                        <v-btn variant="plain" icon="mdi-eye" @click.stop="download(item.Key)" size="small"
                            title="Download"></v-btn>

                    </template>
                </v-data-table>
            </v-col>
        </v-row>


        <v-row><v-col><v-divider></v-divider></v-col></v-row>

        <v-row>
            <v-col>
                <h3>Supplemental Request For Proposal</h3>
            </v-col>
            <v-col class="d-flex ga-4 justify-end" v-if="$hasPermission(`document:generate`)">
                <v-btn color="primary" variant="outlined" @click="generateRequestForProposalSupplementalWorkOrder()">
                    Generate
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-data-table :headers="tableHeaders" :items="requestForProposalSupplementalWorkOrderFileList"
                    :loading="requestForProposalSupplementalWorkOrderFileListLoading" loading-text="Loading..." item-value="Key"
                    :items-per-page="10" ref="dataTable">


                    <template v-slot:[`item.Key`]="{ item }">
                        {{ getFileName(item.Key) }}
                    </template>
                    <template v-slot:[`item.Size`]="{ item }">
                        {{ bytesToSize(item.Size) }}
                    </template>

                    <template v-slot:[`item.LastModified`]="{ item }">
                        <span v-html="getCreatedDate(item.LastModified)"></span>
                    </template>

                    <template v-slot:[`item.Action`]="{ item }">
                        <v-btn variant="plain" icon="mdi-eye" @click.stop="download(item.Key)" size="small"
                            title="Download"></v-btn>
                        <v-btn v-if="$hasPermission(`document:delete`)" variant="plain" icon="mdi-delete"
                            @click.stop="deleteDocument(item.Key, 'requestForProposalFileList')" size="small"
                            title="Delete"></v-btn>

                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-row><v-col><v-divider></v-divider></v-col></v-row>

        <v-row>
            <v-col>
                <h3>Supplemental Final Scope Of Work</h3>
            </v-col>
            <v-col class="d-flex ga-4 justify-end" v-if="$hasPermission(`document:generate`)">
                <v-btn color="primary" variant="outlined" @click="generateFinalScopeOfWorkSupplementalWorkOrder()">
                    Generate
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-data-table :headers="tableHeaders" :items="finalScopeOfWorkSupplementalWorkOrderFileList"
                    :loading="finalScopeOfWorkSupplementalWorkOrderFileListLoading" loading-text="Loading..." item-value="Key"
                    :items-per-page="10">


                    <template v-slot:[`item.Key`]="{ item }">
                        {{ getFileName(item.Key) }}
                    </template>
                    <template v-slot:[`item.Size`]="{ item }">
                        {{ bytesToSize(item.Size) }}
                    </template>

                    <template v-slot:[`item.LastModified`]="{ item }">
                        <span v-html="getCreatedDate(item.LastModified)"></span>
                    </template>

                    <template v-slot:[`item.Action`]="{ item }">
                        <v-btn variant="plain" icon="mdi-eye" @click.stop="download(item.Key)" size="small"
                            title="Download"></v-btn>
                        <v-btn v-if="$hasPermission(`document:delete`)" variant="plain" icon="mdi-delete"
                            @click.stop="deleteDocument(item.Key, 'finalScopeOfWorkSupplementalWorkOrderFileList')" size="small"
                            title="Delete"></v-btn>

                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-row><v-col><v-divider></v-divider></v-col></v-row>

        <v-row>
            <v-col>
                <h3>Supplemental JOC Total Cost Summary</h3>
            </v-col>
            <v-col class="d-flex ga-4 justify-end" v-if="$hasPermission(`document:generate`)">
                <v-btn color="primary" variant="outlined" @click="generateJocTotalCostSummarySupplementalWorkOrder()">
                    Generate
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-data-table :headers="tableHeaders" :items="jocTotalCostSummarySupplementalWorkOrderFileList"
                    :loading="jocTotalCostSummarySupplementalWorkOrderFileListLoading" loading-text="Loading..." item-value="Key"
                    :items-per-page="10">


                    <template v-slot:[`item.Key`]="{ item }">
                        {{ getFileName(item.Key) }}
                    </template>
                    <template v-slot:[`item.Size`]="{ item }">
                        {{ bytesToSize(item.Size) }}
                    </template>

                    <template v-slot:[`item.LastModified`]="{ item }">
                        <span v-html="getCreatedDate(item.LastModified)"></span>
                    </template>

                    <template v-slot:[`item.Action`]="{ item }">
                        <v-btn variant="plain" icon="mdi-eye" @click.stop="download(item.Key)" size="small"
                            title="Download"></v-btn>
                        <v-btn v-if="$hasPermission(`document:delete`)" variant="plain" icon="mdi-delete"
                            @click.stop="deleteDocument(item.Key, 'jocTotalCostSummarySupplementalWorkOrderFileList')" size="small"
                            title="Delete"></v-btn>

                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-row><v-col><v-divider></v-divider></v-col></v-row>

        <v-row>
            <v-col>
                <h3>Supplemental Subcontractor Report</h3>
            </v-col>
            <v-col class="d-flex ga-4 justify-end" v-if="$hasPermission(`document:generate`)">
                <v-btn color="primary" variant="outlined" @click="generateSubcontractorReportSupplementalWorkOrder()">
                    Generate
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-data-table :headers="tableHeaders" :items="subcontractorReportSupplementalWorkOrderFileList"
                    :loading="subcontractorReportSupplementalWorkOrderFileListLoading" loading-text="Loading..." item-value="Key"
                    :items-per-page="10">


                    <template v-slot:[`item.Key`]="{ item }">
                        {{ getFileName(item.Key) }}
                    </template>
                    <template v-slot:[`item.Size`]="{ item }">
                        {{ bytesToSize(item.Size) }}
                    </template>

                    <template v-slot:[`item.LastModified`]="{ item }">
                        <span v-html="getCreatedDate(item.LastModified)"></span>
                    </template>

                    <template v-slot:[`item.Action`]="{ item }">
                        <v-btn variant="plain" icon="mdi-eye" @click.stop="download(item.Key)" size="small"
                            title="Download"></v-btn>
                        <v-btn v-if="$hasPermission(`document:delete`)" variant="plain" icon="mdi-delete"
                            @click.stop="deleteDocument(item.Key, 'subcontractorReportSupplementalWorkOrderFileList')" size="small"
                            title="Delete"></v-btn>

                    </template>
                </v-data-table>
            </v-col>
        </v-row>


        <v-row><v-col><v-divider></v-divider></v-col></v-row>

        <v-row>
            <v-col>
                <h3>Supplemental Job Order Approvals</h3>
            </v-col>
            <v-col class="d-flex ga-4 justify-end" v-if="$hasPermission(`document:generate`)">
                <v-btn color="primary" variant="outlined" @click="generateJobOrderApprovalSupplementalWorkOrder()">
                    Generate
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-data-table :headers="tableHeaders" :items="jobOrderApprovalSupplementalWorkOrderFileList"
                    :loading="jobOrderApprovalSupplementalWorkOrderFileListLoading" loading-text="Loading..." item-value="Key"
                    :items-per-page="10">


                    <template v-slot:[`item.Key`]="{ item }">
                        {{ getFileName(item.Key) }}
                    </template>
                    <template v-slot:[`item.Size`]="{ item }">
                        {{ bytesToSize(item.Size) }}
                    </template>

                    <template v-slot:[`item.LastModified`]="{ item }">
                        <span v-html="getCreatedDate(item.LastModified)"></span>
                    </template>

                    <template v-slot:[`item.Action`]="{ item }">
                        <v-btn variant="plain" icon="mdi-eye" @click.stop="download(item.Key)" size="small"
                            title="Download"></v-btn>
                        <v-btn v-if="$hasPermission(`document:delete`)" variant="plain" icon="mdi-delete"
                            @click.stop="deleteDocument(item.Key, 'jobOrderApprovalSupplementalWorkOrderFileList')" size="small"
                            title="Delete"></v-btn>

                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-row><v-col><v-divider></v-divider></v-col></v-row>

        <v-row>
            <v-col>
                <h3>Supplemental Joint Scope Meeting Invitation</h3>
            </v-col>
            <v-col class="d-flex ga-4 justify-end" v-if="$hasPermission(`document:generate`)">
                <v-btn color="primary" variant="outlined" @click="openJointScopeMeetingDialog()">
                    Generate
                </v-btn>
            </v-col>
        </v-row>


        <v-row>
            <v-col>
                <v-data-table :headers="tableHeaders" :items="jointScopeMeetingInvitationSupplementalWorkOrderFileList"
                    :loading="jointScopeMeetingInvitationSupplementalWorkOrderFileListLoading" loading-text="Loading..." item-value="Key"
                    :items-per-page="10">


                    <template v-slot:[`item.Key`]="{ item }">
                        {{ getFileName(item.Key) }}
                    </template>
                    <template v-slot:[`item.Size`]="{ item }">
                        {{ bytesToSize(item.Size) }}
                    </template>

                    <template v-slot:[`item.LastModified`]="{ item }">
                        <span v-html="getCreatedDate(item.LastModified)"></span>
                    </template>

                    <template v-slot:[`item.Action`]="{ item }">
                        <v-btn variant="plain" icon="mdi-eye" @click.stop="download(item.Key)" size="small"
                            title="Download"></v-btn>
                        <v-btn v-if="$hasPermission(`document:delete`)" variant="plain" icon="mdi-delete"
                            @click.stop="deleteDocument(item.Key, 'jointScopeMeetingInvitationSupplementalWorkOrderFileList')" size="small"
                            title="Delete"></v-btn>

                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <JointScopeMeetingDialogSupplementalWorkOrder :show="showJointScopeMeetingDialog" @closeDialog="closeJointScopeMeetingDialog" />


    </v-container>
</template>
<script setup>
import { useRoute } from 'vue-router';
import { reactive, onMounted, computed, watch, ref } from 'vue';
import ReadHeader from "@/components/interface/ReadHeader.vue";
import KeyValue from "@/components/interface/Key-Value.vue";
import TableList from "@/components/interface/TableList.vue";
import { useEntityCore, useIsCurrentEntityLoaded, useFetchSingle, useFetchList, useNameById, useFormatting } from "@/assets/modules/composables.js";

const route = useRoute();
const isLoading = reactive({});
const alreadyFetchedData = [];
const { entityCore } = useEntityCore();
const { isCurrentEntityLoaded } = useIsCurrentEntityLoaded();
const { fetchSingle } = useFetchSingle(isLoading, alreadyFetchedData);
const { fetchList } = useFetchList(isLoading, alreadyFetchedData);
const { nameById } = useNameById();
const { formatMoney, formatDate } = useFormatting();

import JointScopeMeetingDialogSupplementalWorkOrder from "@/components/entity/supplemental_work_order/JointScopeMeetingDialogSupplementalWorkOrder.vue";
const showJointScopeMeetingDialog = ref(false);

const current = {
    type: "supplemental_work_order",
    id: route.params.entity_id,
};

function openJointScopeMeetingDialog() {
    showJointScopeMeetingDialog.value = true;
}
function closeJointScopeMeetingDialog() {
    showJointScopeMeetingDialog.value = false;
}

const supplementalProposalsDetails = {
    listType: "supplemental_proposal",
    heading: "Supplemental Proposals",
    tableHeaders: [
        // {
        //     title: "ID",
        //     key: "_id",
        // },
        {
            title: "Status",
            key: "core.status",
        },
        {
            title: "Amount",
            key: "calculations.total",
            value: (row) => formatMoney(Number(row.calculations?.total)),
        },
        {
            title: "Date Submitted",
            key: "core.date_submitted",
            value: (row) => formatDate(row.core?.date_submitted),
        },
    ],
};


function generateJobOrderAuthorization() {
    store.dispatch("pdfGenerator", {
        templateType: "job-order-authorization-supplemental-job-order",
        entityId: current.id,
    });
}


// Mutating display data strings
const liquidatedDamagesToDistrict = computed(() => {
    return entityCore.value.liquidated_damages_to_district ? "$" + entityCore.value.liquidated_damages_to_district + " per calendar day" : null;
})
const liquidatedDamagesToContractor = computed(() => {
    return entityCore.value.liquidated_damages_to_contractor ? "$" + entityCore.value.liquidated_damages_to_contractor + " per calendar day" : null;
})
const jambFeePerecentage = computed(() => {
    return entityCore.value.jamb_fee_percentage ? entityCore.value.jamb_fee_percentage + "%" : null;
})
import { useStore } from 'vuex';
const store = useStore();
const jobOrderAuthorizationFileList = ref([]);
const jobOrderAuthorizationFileListLoading = ref(true);
const requestForProposalSupplementalWorkOrderFileList = ref([]);
const requestForProposalSupplementalWorkOrderFileListLoading = ref(true);
const finalScopeOfWorkSupplementalWorkOrderFileList = ref([]);
const finalScopeOfWorkSupplementalWorkOrderFileListLoading = ref(true);
const jocTotalCostSummarySupplementalWorkOrderFileList = ref([]);
const jocTotalCostSummarySupplementalWorkOrderFileListLoading = ref(true);
const subcontractorReportSupplementalWorkOrderFileList = ref([]);
const subcontractorReportSupplementalWorkOrderFileListLoading = ref(true);
const jobOrderApprovalSupplementalWorkOrderFileList = ref([]);
const jobOrderApprovalSupplementalWorkOrderFileListLoading = ref(true);
const jointScopeMeetingInvitationSupplementalWorkOrderFileList = ref([]);
const jointScopeMeetingInvitationSupplementalWorkOrderFileListLoading = ref(true);
watch(isCurrentEntityLoaded, async () => {
    if (isCurrentEntityLoaded.value) {
        fetchSingle("contract", entityCore.value.contract_uid);
        fetchSingle("owner_contact", entityCore.value.owner_project_manager_primary_uid);
        fetchSingle("owner_contact", entityCore.value.owner_project_manager_2_uid);
        fetchSingle("owner_contact", entityCore.value.owner_project_manager_3_uid);
        fetchSingle("contractor_contact", entityCore.value.contractor_project_manager_primary_uid);
        fetchSingle("contractor_contact", entityCore.value.contractor_project_manager_2_uid)
        fetchSingle("contractor_contact", entityCore.value.contractor_project_manager_3_uid);
        fetchSingle("owner_contact", entityCore.value.inspector_uid);
        fetchSingle("owner_contact", entityCore.value.rfp_signing_authority_uid);
        fetchSingle("owner_contact", entityCore.value.ntp_signing_authority_uid);
        fetchSingle("client_contact", entityCore.value.woa_signing_authority_uid);

        jobOrderAuthorizationFileList.value = await getJobOrderAuthorizationList();
        jobOrderAuthorizationFileListLoading.value = false;
        requestForProposalSupplementalWorkOrderFileList.value = await getRequestForProposalSupplementalWorkOrderList();
        requestForProposalSupplementalWorkOrderFileListLoading.value = false;
        finalScopeOfWorkSupplementalWorkOrderFileList.value = await getFinalScopeOfWorkSupplementalWorkOrderList();
        finalScopeOfWorkSupplementalWorkOrderFileListLoading.value = false;
        jocTotalCostSummarySupplementalWorkOrderFileList.value = await getJocTotalCostSummarySupplementalWorkOrderList();
        jocTotalCostSummarySupplementalWorkOrderFileListLoading.value = false;
        subcontractorReportSupplementalWorkOrderFileList.value = await getSubcontractorReportSupplementalWorkOrderList();
        subcontractorReportSupplementalWorkOrderFileListLoading.value = false;
        jobOrderApprovalSupplementalWorkOrderFileList.value = await getJobOrderApprovalSupplementalWorkOrderList();
        jobOrderApprovalSupplementalWorkOrderFileListLoading.value = false;
        jointScopeMeetingInvitationSupplementalWorkOrderFileList.value = await getJointScopeMeetingInvitationSupplementalWorkOrderList();
        jointScopeMeetingInvitationSupplementalWorkOrderFileListLoading.value = false;
    }
})
onMounted(() => {
    fetchList("supplemental_proposal", "supplemental_work_order-" + current.id);
})
async function getJobOrderAuthorizationList() {
    const entityPath = store.getters.getEntityDocument(current.id)?._path
    const items = await store.dispatch("fetchFileListDataVersionTwo", {
        templateType: "job-order-authorization-supplemental-job-order",
        entityPath: entityPath,
    });

    return items || [];
}
const tableHeaders = [
    {
        title: "Key",
        key: "Key",
    },
    // {
    //     title: "Size",
    //     key: "Size",
    // },
    {
        title: "Created",
        key: "LastModified",
    },
    {
        title: "Action",
        key: "Action",
        width: 120,
        sortable: false,
    }
];
function bytesToSize(bytes) {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
    if (bytes === 0) return 'n/a'
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
    if (i === 0) return `${bytes} ${sizes[i]})`
    return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`
}
function getCreatedDate(dateStr) {
    const date = new Date(dateStr);
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
    };
    const formattedDate = date.toLocaleString('en-US', options);
    const [datePart, timePart] = formattedDate.split(', ');
    return `${datePart}<br/><span class="created-date">${timePart}</span>`;
}
function getFileName(Key) {
    const parts = Key.split("/");
    return parts[parts.length - 1];
}
async function download(Key) {
    var loadPayload = {
        Key: Key
    };

    await store.dispatch("fetchDownload", loadPayload)
}
function generateRequestForProposalSupplementalWorkOrder() {
    store.dispatch("pdfGenerator", {
        templateType: "request-for-proposal-supplemental-work-order",
        entityId: current.id,
    });
}
function generateFinalScopeOfWorkSupplementalWorkOrder() {
    store.dispatch("pdfGenerator", {
        templateType: "final-scope-of-work-supplemental-work-order",
        entityId: current.id,
    });
}
function generateJocTotalCostSummarySupplementalWorkOrder() {
    store.dispatch("pdfGenerator", {
        templateType: "joc-total-cost-summary-supplemental-work-order",
        entityId: current.id,
    });
}
async function generateSubcontractorReportSupplementalWorkOrder() {
    store.dispatch("pdfGenerator", {
        templateType: "subcontractor-report-supplemental-work-order",
        entityId: current.id,
    });
}
async function generateJobOrderApprovalSupplementalWorkOrder() {
    store.dispatch("pdfGenerator", {
        templateType: "job-order-approval-supplemental-work-order",
        entityId: current.id,
    });
}
const deleteDocument = async (documentKey, listName) => {
    const deleteResponse = await store.dispatch("deleteDocument", documentKey);
    if (deleteResponse) {
        switch (listName) {
            case 'requestForProposalSupplementalWorkOrderFileList':
                requestForProposalSupplementalWorkOrderFileList.value = [];
                break;
            case 'finalScopeOfWorkSupplementalWorkOrderFileList':
                finalScopeOfWorkSupplementalWorkOrderFileList.value = [];
                break;
            case 'jocTotalCostSummarySupplementalWorkOrderFileList':
                jocTotalCostSummarySupplementalWorkOrderFileList.value = [];
                break;
            case 'subcontractorReportSupplementalWorkOrderFileList':
                subcontractorReportSupplementalWorkOrderFileList.value = [];
                break;
            case 'jobOrderApprovalSupplementalWorkOrderFileList':
                jobOrderApprovalSupplementalWorkOrderFileList.value = [];
                break;
            case 'jointScopeMeetingInvitationSupplementalWorkOrderFileList':
                jointScopeMeetingInvitationSupplementalWorkOrderFileList.value = [];
                break;
            default:
                console.error('Unknown list name:', listName);
        }
    }
};
async function getRequestForProposalSupplementalWorkOrderList() {
    const entityPath = store.getters.getEntityDocument(current.id)?._path
    const items = await store.dispatch("fetchFileListDataVersionTwo", {
        templateType: "request-for-proposal-supplemental-work-order",
        entityPath: entityPath,
    });
    // console.log("getRequestForProposalList items",items)
    return items || [];
}
async function getFinalScopeOfWorkSupplementalWorkOrderList() {
    const entityPath = store.getters.getEntityDocument(current.id)?._path
    const items = await store.dispatch("fetchFileListDataVersionTwo", {
        templateType: "final-scope-of-work-supplemental-work-order",
        entityPath: entityPath,
    });
    return items || [];
}
async function getJocTotalCostSummarySupplementalWorkOrderList() {
    const entityPath = store.getters.getEntityDocument(current.id)?._path
    const items = await store.dispatch("fetchFileListDataVersionTwo", {
        templateType: "joc-total-cost-summary-supplemental-work-order",
        entityPath: entityPath,
    });
    return items || [];
}
async function getSubcontractorReportSupplementalWorkOrderList() {
    const entityPath = store.getters.getEntityDocument(current.id)?._path
    const items = await store.dispatch("fetchFileListDataVersionTwo", {
        templateType: "subcontractor-report-supplemental-work-order",
        entityPath: entityPath,
    });
    return items || [];
}
async function getJobOrderApprovalSupplementalWorkOrderList() {
    const entityPath = store.getters.getEntityDocument(current.id)?._path
    const items = await store.dispatch("fetchFileListDataVersionTwo", {
        templateType: "job-order-approval-supplemental-work-order",
        entityPath: entityPath,
    });
    return items || [];
}
async function getJointScopeMeetingInvitationSupplementalWorkOrderList() {
    const entityPath = store.getters.getEntityDocument(current.id)?._path
    const items = await store.dispatch("fetchFileListDataVersionTwo", {
        templateType: "joint-scope-meeting-invitation-supplemental-work-order",
        entityPath: entityPath,
    });
    return items || [];
}
</script>